import { css, Theme } from '@emotion/react'

export const headerSection = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`

export const title = (theme: Theme) => css`
  text-align: center;
  color: ${theme.typographyColors.typographyTwo};
  font-size: 24px;
  font-weight: 700;
  margin: 0;
`

export const form = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-self: stretch;
`

export const fieldSection = css`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 14px;
`

export const submitButton = css`
  height: 48px;
  border-radius: 14px;
  font-weight: 700;
  margin-top: 8px;
`
